var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropzone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "183px",
    height: "141px",
    viewBox: "0 0 183 141",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "upload-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "026---3RD-Party-Upload-Workflow-Default",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4.1---L---Upload-Collaborator",
    transform: "translate(-637.000000, -861.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(519.000000, 829.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "upload-icon",
    transform: "translate(120.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#A3DDBC",
    cx: 89.5,
    cy: 70.5,
    r: 70.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "iconfinder_development_upload_laptop_arrow_4552619",
    transform: "translate(0.000000, 35.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 23.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.385216, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 2.29679219,
    y: 2.26530612,
    width: 82.3849372,
    height: 61.9183673
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.67266388,60.5454545 C0.749353417,60.5454545 0,59.792 0,58.8636364 L0,5.04545455 C0,2.26372727 2.25140558,0 5.01799163,0 L21.7479757,0 C22.6712862,0 23.4206396,0.753454545 23.4206396,1.68181818 C23.4206396,2.61018182 22.6712862,3.36363636 21.7479757,3.36363636 L5.01799163,3.36363636 C4.0980265,3.36363636 3.34532775,4.12045455 3.34532775,5.04545455 L3.34532775,58.8636364 C3.34532775,59.792 2.59597434,60.5454545 1.67266388,60.5454545 Z",
    id: "Path",
    fill: "#263238",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3058577,60.5454545 C84.3825473,60.5454545 83.6331939,59.792 83.6331939,58.8636364 L83.6331939,5.04545455 C83.6331939,4.12045455 82.8804951,3.36363636 81.96053,3.36363636 L65.2338912,3.36363636 C64.3105808,3.36363636 63.5612273,2.61018182 63.5612273,1.68181818 C63.5612273,0.753454545 64.3105808,0 65.2338912,0 L81.96053,0 C84.727116,0 86.9785216,2.26372727 86.9785216,5.04545455 L86.9785216,58.8636364 C86.9785216,59.792 86.2291682,60.5454545 85.3058577,60.5454545 Z",
    id: "Path",
    fill: "#263238",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 0.374476987,
    y1: 42.6632653,
    x2: 47.5585774,
    y2: 42.6632653,
    id: "Line-2",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 131.441423,
    y1: 42.6632653,
    x2: 178.625523,
    y2: 42.6632653,
    id: "Line-2-Copy",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.691074,74 L48.0578801,74 C43.4446731,74 39.6945607,70.2293636 39.6945607,65.5909091 C39.6945607,64.6625455 40.4439141,63.9090909 41.3672245,63.9090909 L78.1658298,63.9090909 C79.0891403,63.9090909 79.8384937,64.6625455 79.8384937,65.5909091 C79.8384937,66.5192727 79.0891403,67.2727273 78.1658298,67.2727273 L43.3275866,67.2727273 C44.0167241,69.2303636 45.8767264,70.6363636 48.0578801,70.6363636 L131.691074,70.6363636 C133.872228,70.6363636 135.73223,69.2303636 136.421367,67.2727273 L101.583124,67.2727273 C100.659814,67.2727273 99.9104603,66.5192727 99.9104603,65.5909091 C99.9104603,64.6625455 100.659814,63.9090909 101.583124,63.9090909 L138.381729,63.9090909 C139.30504,63.9090909 140.054393,64.6625455 140.054393,65.5909091 C140.054393,70.2293636 136.304281,74 131.691074,74 Z",
    id: "Path",
    fill: "#263238",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "transfer_9_",
    transform: "translate(74.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,25.0720294 L16.6304348,2.25882353 L31.8693631,25.6 L25.1834779,25.6 L24.133296,43.022533 L8.59678147,42.1647059 C8.59678147,35.1221127 8.59678147,29.9979975 8.59678147,26.7923602 C8.59678147,23.586723 5.73118765,23.0132794 0,25.0720294 Z",
    id: "Rectangle",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.32186957,64 C7.40386957,64 6.65882609,63.2454737 6.65882609,62.3157895 L6.65882609,26.9473684 L1.66969565,26.9473684 C1.06102174,26.9473684 0.498913043,26.6105263 0.212869565,26.0682105 C-0.079826087,25.5292632 -0.0565434783,24.8724211 0.27273913,24.3503158 L15.2401304,0.771368421 C15.8587826,-0.188631579 17.4220435,-0.188631579 18.0406957,0.771368421 L33.008087,24.3503158 C33.3373696,24.8690526 33.3573261,25.5292632 33.0679565,26.0682105 C32.7752609,26.6105263 32.2131522,26.9473684 31.6044783,26.9473684 L26.6153478,26.9473684 L26.6153478,55.5789474 C26.6153478,56.5086316 25.8703043,57.2631579 24.9523043,57.2631579 C24.0343043,57.2631579 23.2892609,56.5086316 23.2892609,55.5789474 L23.2892609,25.2631579 C23.2892609,24.3334737 24.0343043,23.5789474 24.9523043,23.5789474 L28.5577826,23.5789474 L16.637087,4.8 L4.7163913,23.5789474 L8.32186957,23.5789474 C9.23986957,23.5789474 9.98491304,24.3334737 9.98491304,25.2631579 L9.98491304,62.3157895 C9.98491304,63.2454737 9.23986957,64 8.32186957,64 Z",
    id: "Path",
    fill: "#263238",
    fillRule: "nonzero"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropzone);
export default __webpack_public_path__ + "static/media/dropzone.e286e2b14780b7757341d0fff4a7be37.svg";
export { ForwardRef as ReactComponent };